import { Action } from 'redux';
import { Days } from '../entities';

export enum TActiveDay {
  SET_DAY = 'SET_DAY',
}

export interface ISetDay extends Action {
  type: TActiveDay.SET_DAY;
  payload: Days;
}

export const ASetDay = (payload: Days): ISetDay => ({ type: TActiveDay.SET_DAY, payload });
